import React, { useState, useEffect } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Skeleton from "@material-ui/lab/Skeleton";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Switch from '@material-ui/core/Switch';
import FormLabel from '@material-ui/core/FormLabel';
import { useForm } from "react-hook-form";
import { useAuth } from "./../util/auth";
import { Link, useRouter } from './../util/router.js';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { useItem, updateItem, createItem, uploadImage, uploadImageFromURL, useItemsMutation } from "./../util/db";
import { apiRequest } from "../util/util";
import PromptWarning from "./PromptWarning.js";
import {CheckBoxOutlined} from "@material-ui/icons";
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

Array.prototype.sample = function(){
  return this[Math.floor(Math.random()*this.length)];
}

const generateSeed = () => {
  // Generate a random seed by reading 2 bytes from the operating system's random source
  // and interpreting them as an integer in big-endian order.
  
  // Generate 2 random bytes
  let randomBytes = new Uint8Array(2);
  window.crypto.getRandomValues(randomBytes);
  
  // Interpret the bytes as an integer in big-endian order
  const seed = (randomBytes[0] << 8) | randomBytes[1];
  return seed
}

const useStyles = makeStyles((theme) => ({
  media: {
    height: 160,
  },
}));

function Generator(props) {
  const classes = useStyles();
  const auth = useAuth();
  const router = useRouter();
  const [prediction, setPrediction] = useState(null);
  const [error, setError] = useState(null);
  const [pending, setPending] = useState(false);
  const [adjustedUserPrompt, setAdjustedUserPrompt] = useState("");
  const [adjustedUserNegativePrompt, setAdjustedUserNeagtivePrompt] = useState("");
  const [showWarning, setShowWarning] = useState(false);

  const [inputData, setInputData] = useState({
    prompt: router.query.prompt || "beautiful asian girl",
    negativePrompt: router.query.negativePrompt||"",
    style: router.query.style || "real",
    pose: router.query.pose || "Default",
    isPrivate: false,
  })

  const {prompt, negativePrompt, style, pose, isPrivate} = inputData
  
  const handleChange = (event) => {
    const {name, value} = event.target
    setInputData((prevData) => ({...prevData, [name]: value }));
  };

  const handleStyleClick = (style) => {
    setInputData((prevData) => ({...prevData, style: style }));
  };

  const handleSwitch = (event) => {
    if(auth.user && auth.user.planIsActive && auth.user.planId === 'premium'){
      setInputData((prevData) => ({...prevData, [event.target.name]: event.target.checked }));
    }
    else {
      alert("Upgrade to pro to use this feature")
    }
  }


  const modelStyles = [
    {
      image:
        "https://i.imgur.com/RxwaNAG.png",
      value: "real",
      text: "Real",
      goodPrompt: 'RAW photo, SUBJECT, 8k uhd, dslr, soft lighting, high quality, film grain, Fujifilm XT3',
      badPrompt: '(easynegative, ng_deepnegative_v1_75t, SUBJECT, deformed iris, deformed pupils, semi-realistic, cgi, 3d, render, sketch, cartoon, drawing, anime), text, cropped, out of frame, worst quality, low quality, jpeg artifacts, ugly, duplicate, morbid, mutilated, extra fingers, mutated hands, poorly drawn hands, poorly drawn face, mutation, deformed, blurry, dehydrated, bad anatomy, bad proportions, extra limbs, cloned face, disfigured, gross proportions, malformed limbs, missing arms, missing legs, extra arms, extra legs, fused fingers, too many fingers, long neck, UnrealisticDream'
    },
    {
      image:
        "https://i.imgur.com/Vk2vZE8.png",
      value: "hyperreal",
      text: "Hyper Real",
      goodPrompt: '((photo, high quality, high resolution, 4k, hd, hdr, dslr)), 1girl, SUBJECT',
      badPrompt: 'easynegative, ng_deepnegative_v1_75t, SUBJECT, paintings, sketches, digital arts, (worst quality:2), (low quality:2), (normal quality:2), low resolution, ((monochrome)), ((grayscale)), watermark, out of frame, (ugly:1.2), people'
    },
    {
      image:
        "https://i.imgur.com/Ya2D8Jm.png",
      value: "anime",
      text: "Anime",
      goodPrompt: 'masterpiece, best quality, 1girl, SUBJECT',
      badPrompt: 'easynegative, ng_deepnegative_v1_75t, SUBJECT, (low quality, worst quality:1.4), lowres, bad anatomy, bad hands, normal quality, ((monochrome)), ((grayscale))'
    },
    {
      image:
        "https://i.imgur.com/BvUipcx.png",
      value: "hyperanime",
      text: "Hyper Anime",
      goodPrompt: '((best quality)), ((masterpiece)), (detailed), SUBJECT, (high detailed skin:1. 2), small details, photorealistic, 1girl, 8k uhd, soft lighting, anime',
      badPrompt: 'easynegative, ng_deepnegative_v1_75t, SUBJECT, (worst quality:2), (low quality:2), (normal quality:2), lowres, bad anatomy, bad hands, normal quality, ((monochrome)), ((grayscale))'
    },
  ];

  const modelPoses = ['Default', 'POV BlowJob', 'POV DoggyStyle', 'HandJob', 'Flashing Boobs', 'Stick Out Tongue', 'Grab Ass', 'POV Anal', 'Vagina Spread', 'Female Masturbation', 'TitJob', 'Bukkake', 'Spooning', 'POV Missionary', 'Cheek Bulge BlowJob', 'Solo Breast Grab', 'Resting on Stomach', 'BlowJob Under Desk', 'Front View CowGirl', 'POV SpitRoast', 'POV Reverse CowGirl']

  const PROMPTS = [
    "Confident Afro-Latina beauty, natural curls, bold tribal prints. Embracing her rich heritage with pride.",
    "Energetic Asian athlete, determined gaze, sports jersey. Breaking barriers and chasing dreams.",
    "Radiant Indigenous woman, traditional regalia, adorned with intricate beadwork. Honoring her ancestral legacy.",
    "Chic South Asian artist, vibrant saree, henna-adorned hands. Painting her world with vivid colors.",
    "Inspirational disability activist, adaptive fashion, unstoppable spirit. Redefining beauty on her terms.",
    "Effervescent Afro-Caribbean dancer, vibrant headwrap, colorful dance attire. Expressing joy through movement.",
    "Tech-savvy Middle Eastern coder, modern attire, glasses. Navigating the digital realm with brilliance.",
    "Confident plus-size model, bold fashion choices, radiant smile. Redefining standards of beauty.",
    "Trailblazing East Asian CEO, power suit, poised confidence. Shattering glass ceilings with determination.",
    "Empathetic Latina nurse, scrubs adorned with pins, caring demeanor. A healing touch and compassionate heart.",
    "Resilient Indigenous activist, native jewelry, traditional-inspired attire. Advocating for her people with pride.",
    "Empowered African entrepreneur, Ankara prints, fierce determination. Building a legacy of success.",
    "Inclusive fashion designer, diverse models, runway full of beauty. Celebrating every body and identity.",
    "Passionate South Asian environmentalist, eco-friendly attire, earth-loving spirit. Nurturing the planet with love.",
    "Bold Middle Eastern journalist, microphone in hand. Amplifying voices that need to be heard.",
    "Courageous Latina firefighter, uniform adorned with badges, strength in action. Fearlessly protecting her community.",
    "Visionary Native American coder, modern fashion with traditional elements. Pioneering innovation with respect.",
    "Trailblazing South Asian astronaut, spacesuit with cultural motifs. Reaching for the stars and beyond.",
    "Empowered Latina educator, teaching with heart. Nurturing young minds with knowledge.",
    "Resilient Afro-Caribbean artist, unique jewelry, creative spirit. Preserving heritage through artistry.",
    "Empowered Asian engineer, safety gear, innovative mindset. Building a better world through technology.",
    "Confident Latina athlete, sports jersey, fierce determination. Breaking records and shattering stereotypes.",
    "Bold Indigenous designer, contemporary and native fusion, creative expression. Redefining style norms.",
    "Trailblazing architect, blueprint in hand. Building spaces that blend beauty and function.",
    "Empowered Afro-Latina musician, bold stage outfits, melodic soul. Sharing stories through music's embrace.",
    "Energetic Asian dancer, diverse dance attire, rhythmic motion. Captivating audiences with her artistry.",
    "Resilient lawyer, modern suit with cultural accessories. Seeking justice with wisdom and strength.",
    "Passionate scientist, lab coat, curious eyes. Exploring the mysteries of the universe with brilliance.",
    "Inclusive plus-size fashion designer, diverse models, runway of beauty. Celebrating every body and story.",
    "Visionary engineer, innovative mindset, changing the world. Transforming ideas into reality.",
    "Courageous firefighter, uniform with pride, fearless service. Protecting lives and communities.",
    "Empowered Indigenous artist, intricate beadwork, creative soul. Preserving culture through artistic expression.",
    "Inspiring CEO, power suit, confident leadership. Breaking barriers and forging success.",
    "Passionate activist, traditional and modern fusion, dedicated heart. Fighting for equality and change.",
    "Chic filmmaker, powerful narratives. Amplifying diverse voices through film.",
    "Bold tech genius, diverse team, brilliant innovation. Transforming industries with diversity.",
    "Trailblazing politician, traditional and modern fusion, leadership in action. Advocating for her people.",
    "Empowered artist, expressive headscarf, vibrant canvas. Creating beauty through colors and forms.",
    "Courageous plus-size fitness instructor, active wear, inspiring movement. Championing health at every size.",
    "Resilient therapist, comforting attire, healing touch. Nurturing emotional well-being with care.",
    "Inspirational entrepreneur, innovative ideas, determined ambition. Building a legacy of success.",
    "Passionate disability rights advocate, adaptive fashion, unwavering voice. Amplifying the call for inclusivity.",
    "Empowered musician, diverse instruments, melodious soul. Connecting hearts through music.",
    "Visionary scientist, lab coat, inquisitive exploration. Uncovering truths that shape our world.",
    "Bold athlete, sports jersey, determination in her eyes. Pushing boundaries and chasing dreams.",
    "Empowered chef, culinary creativity, ancestral connection. Infusing traditions into flavors.",
    "Trailblazing artist, diverse canvas, vivid imagination. Creating visual stories that inspire.",
    "Confident CEO, modern attire, visionary outlook. Leading with determination and innovation.",
    "Chic educator, classroom full of diverse minds, nurturing growth. Illuminating paths to knowledge.",
    "Empowered engineer, hard hat and plans, shaping the world with her expertise.",
    "Passionate environmentalist, eco-conscious attire, earth-loving heart. Nurturing the planet with care.",
    "Resilient lawyer, power suit, unwavering advocacy. Seeking justice and equality with determination.",
    "Inspiring astronaut, spacesuit with a spirit of exploration. Embarking on journeys beyond our world.",
    "Courageous artist, paint-splattered clothes, boundless creativity. Transforming thoughts into masterpieces.",
    "Visionary journalist, microphone in hand, fearless reporting. Amplifying stories that need to be told.",
    "Empowered chef, culinary magic, infusing flavors with love. Creating dishes that inspire connection.",
    "Inspirational educator, diverse classroom, igniting curiosity. Nurturing young minds with passion.",
    "Energetic athlete, sports gear, determination in her stride. Pursuing excellence with dedication.",
    "Resilient scientist, lab coat, exploring the unknown with curiosity. Uncovering the secrets of nature.",
    "Passionate designer, sketchbook in hand, shaping ideas into reality. Creating spaces that inspire.",
    "Bold musician, instruments at her fingertips, creating harmonies that touch the soul.",
    "Trailblazing entrepreneur, modern attire, driving innovation with passion. Building her own path to success.",
    "Courageous activist, determined spirit, fighting for change with unwavering resolve.",
    "Empowered filmmaker, camera in hand, capturing stories that need to be heard.",
    "Confident engineer, tools of her trade, building a future of possibility and progress.",
    "Chic architect, blueprint and vision, transforming spaces with creativity.",
    "Inspiring athlete, sports jersey, fierce dedication on and off the field. Setting an example of perseverance.",
    "Visionary artist, vibrant palette, expressing emotions through colors and strokes.",
    "Energetic journalist, notepad in hand, seeking truth and bringing stories to light.",
    "Resilient chef, kitchen full of aromas, blending tradition and innovation in every dish.",
    "Passionate teacher, classroom of eager minds, nurturing a love for learning. Guiding futures with care.",
    "Empowered photographer, camera capturing moments of truth and beauty.",
    "Trailblazing musician, diverse instruments, uniting cultures through the language of music.",
    "Courageous designer, fabrics and patterns, shaping styles that tell stories.",
    "Inspirational scientist, microscope and curiosity, unlocking the secrets of the natural world.",
    "Bold entrepreneur, startup dreams, forging her own path with courage.",
    "Confident activist, megaphone in hand, leading change with determination.",
    "Chic filmmaker, capturing stories that touch hearts and open minds.",
    "Empowered engineer, gears and gadgets, crafting solutions for a better tomorrow.",
    "Passionate athlete, sports jersey, pushing her limits and inspiring others.",
    "Resilient artist, canvas and colors, channeling emotions into visual expressions.",
    "Visionary educator, books and knowledge, shaping the future one student at a time.",
    "Elegant Nordic beauty, fair complexion, flowing blonde hair like a cascade of sunshine.",
  "Enigmatic East Asian allure, almond-shaped eyes, jet-black hair framing her delicate features.",
  "Spirited African queen, rich ebony skin, natural hair adorned with intricate braids.",
  "Captivating Mediterranean charm, olive skin, dark wavy hair that dances with the breeze.",
  "Radiant South Asian vision, warm brown eyes, long cascading tresses that shimmer like silk.",
  "Intriguing Middle Eastern mystique, expressive hazel eyes that hold a thousand stories.",
  "Alluring Latina enchantress, sun-kissed skin, voluminous waves of chestnut hair.",
  "Exotic Pacific Islander grace, luminous smile, adorned with vibrant floral accessories.",
  "Majestic Indigenous heritage, deep mahogany skin, hair adorned with feathers and beads.",
  "Charming European elegance, porcelain complexion, fiery locks that cascade down her back.",
  "Magnetic Caribbean beauty, golden skin kissed by the sun, dreadlocks swaying with every step.",
  "Graceful East African queen, mahogany skin that radiates warmth, adorned with traditional jewelry.",
  "Seductive South American allure, bronzed skin that tells tales of adventures under the sun.",
  "Mysterious North African beauty, almond-shaped eyes that gleam with ancient wisdom.",
  "Exquisite East European grace, fair skin like porcelain, eyes as blue as the sky.",
  "Enchanting South Pacific goddess, bronze skin that glistens with the ocean's touch.",
  "Mesmerizing West Asian allure, expressive eyes that hold the allure of a desert oasis.",
  "Captivating Caribbean charm, rich brown skin that exudes confidence and vibrancy.",
  "Radiant Central Asian beauty, delicate features that capture the essence of the Silk Road.",
  "Intriguing North American vision, a mix of cultures reflected in her unique blend of beauty.",
  "Sultry South European allure, dark eyes that hold a depth of passion and history.",
  "Majestic East Indian queen, dark eyes that shine with intellect and grace.",
  "Elegant Nordic beauty, fair complexion, flowing blonde hair like a cascade of sunshine.",
  "Enigmatic East Asian allure, almond-shaped eyes, jet-black hair framing her delicate features.",
  "Spirited African queen, rich ebony skin, natural hair adorned with intricate braids.",
  "Captivating Mediterranean charm, olive skin, dark wavy hair that dances with the breeze.",
  "Radiant South Asian vision, warm brown eyes, long cascading tresses that shimmer like silk.",
  "Intriguing Middle Eastern mystique, expressive hazel eyes that hold a thousand stories.",
  "Alluring Latina enchantress, sun-kissed skin, voluminous waves of chestnut hair.",
  "Exotic Pacific Islander grace, luminous smile, adorned with vibrant floral accessories.",
  "Majestic Indigenous heritage, deep mahogany skin, hair adorned with feathers and beads.",
  "Charming European elegance, porcelain complexion, fiery locks that cascade down her back.",
  "Magnetic Caribbean beauty, golden skin kissed by the sun, dreadlocks swaying with every step.",
  "Graceful East African queen, mahogany skin that radiates warmth, adorned with traditional jewelry.",
  "Seductive South American allure, bronzed skin that tells tales of adventures under the sun.",
  "Mysterious North African beauty, almond-shaped eyes that gleam with ancient wisdom.",
  "Exquisite East European grace, fair skin like porcelain, eyes as blue as the sky.",
  "Enchanting South Pacific goddess, bronze skin that glistens with the ocean's touch.",
  "Mesmerizing West Asian allure, expressive eyes that hold the allure of a desert oasis.",
  "Captivating Caribbean charm, rich brown skin that exudes confidence and vibrancy.",
  "Radiant Central Asian beauty, delicate features that capture the essence of the Silk Road.",
  "Intriguing North American vision, a mix of cultures reflected in her unique blend of beauty.",
  "Sultry South European allure, dark eyes that hold a depth of passion and history.",
  "Majestic East Indian queen, dark eyes that shine with intellect and grace.",
  "Elegant Nordic beauty, fair complexion, flowing blonde hair like a cascade of sunshine.",
  "Enigmatic East Asian allure, almond-shaped eyes, jet-black hair framing her delicate features.",
  "Spirited African queen, rich ebony skin, natural hair adorned with intricate braids.",
  "Captivating Mediterranean charm, olive skin, dark wavy hair that dances with the breeze.",
  "Radiant South Asian vision, warm brown eyes, long cascading tresses that shimmer like silk.",
  "Intriguing Middle Eastern mystique, expressive hazel eyes that hold a thousand stories.",
  "Alluring Latina enchantress, sun-kissed skin, voluminous waves of chestnut hair.",
  "Exotic Pacific Islander grace, luminous smile, adorned with vibrant floral accessories.",
  "Majestic Indigenous heritage, deep mahogany skin, hair adorned with feathers and beads.",
  "Charming European elegance, porcelain complexion, fiery locks that cascade down her back.",
  "Magnetic Caribbean beauty, golden skin kissed by the sun, dreadlocks swaying with every step.",
  "Graceful East African queen, mahogany skin that radiates warmth, adorned with traditional jewelry.",
  "Seductive South American allure, bronzed skin that tells tales of adventures under the sun.",
  "Mysterious North African beauty, almond-shaped eyes that gleam with ancient wisdom.",
  "Exquisite East European grace, fair skin like porcelain, eyes as blue as the sky.",
  "Enchanting South Pacific goddess, bronze skin that glistens with the ocean's touch.",
  "Mesmerizing West Asian allure, expressive eyes that hold the allure of a desert oasis.",
  "Captivating Caribbean charm, rich brown skin that exudes confidence and vibrancy.",
  "Radiant Central Asian beauty, delicate features that capture the essence of the Silk Road.",
  "Intriguing North American vision, a mix of cultures reflected in her unique blend of beauty.",
  "Sultry South European allure, dark eyes that hold a depth of passion and history.",
  "Majestic East Indian queen, dark eyes that shine with intellect and grace.",
  "Elegant Nordic beauty, fair complexion, flowing blonde hair like a cascade of sunshine.",
  "Enigmatic East Asian allure, almond-shaped eyes, jet-black hair framing her delicate features.",
  "Spirited African queen, rich ebony skin, natural hair adorned with intricate braids.",
  "Captivating Mediterranean charm, olive skin, dark wavy hair that dances with the breeze.",
  "Radiant South Asian vision, warm brown eyes, long cascading tresses that shimmer like silk.",
  "Intriguing Middle Eastern mystique, expressive hazel eyes that hold a thousand stories.",
  "Alluring Latina enchantress, sun-kissed skin, voluminous waves of chestnut hair.",
  "Exotic Pacific Islander grace, luminous smile, adorned with vibrant floral accessories.",
  "Majestic Indigenous heritage, deep mahogany skin, hair adorned with feathers and beads.",
  "Charming European elegance, porcelain complexion, fiery locks that cascade down her back.",
  "Magnetic Caribbean beauty, golden skin kissed by the sun, dreadlocks swaying with every step.",
  "Graceful East African queen, mahogany skin that radiates warmth, adorned with traditional jewelry.",
  "Seductive South American allure, bronzed skin that tells tales of adventures under the sun.",
  "Mysterious North African beauty, almond-shaped eyes that gleam with ancient wisdom.",
  "Exquisite East European grace, fair skin like porcelain, eyes as blue as the sky.",
  "Enchanting South Pacific goddess, bronze skin that glistens with the ocean's touch.",
  "Mesmerizing West Asian allure, expressive eyes that hold the allure of a desert oasis.",
  "Captivating Caribbean charm, rich brown skin that exudes confidence and vibrancy.",
  "Radiant Central Asian beauty, delicate features that capture the essence of the Silk Road.",
  "Intriguing North American vision, a mix of cultures reflected in her unique blend of beauty.",
  "Sultry South European allure, dark eyes that hold a depth of passion and history.",
  "Majestic East Indian queen, dark eyes that shine with intellect and grace."
  ]


  const wordList = {
    abuse: "party",
    "acid attack": "adult",
    adolescent: "adult",
    babyish: "adult",
    baby:"young",
    "black market": "adult",
    bullying: "adult",
    callow: "adult",
    child: "adult",
    little:"adult",
    childish: "adult",
    Child: "adult",
    childlike: "adult",
    children: "adult",
    contraband: "adult",
    "criminal behavior": "adult",
    embryonic: "adult",
    ephebic: "adult",
    exploitation: "adult",
    felony: "adult",
    flowering: "adult",
    forced: "adult",
    fraud: "adult",
    gore:"dancing",
    harassment: "adult",
    trafficking: "adult",
    illegal: "adult",
    illicit: "adult",
    immature: "adult",
    assault: "adult",
    infanticide: "adult",
    infantile: "adult",
    infantine: "adult",
    juvenile: "adult",
    kiddish: "adult",
    lawbreaking: "adult",
    molestation: "adult",
    "money laundering": "adult",
    pittey: "adult",
    preteen: "adult",
    preteens: "adult",
    prostitution: "adult",
    pubescent: "adult",
    puerile: "adult",
    rape: "adult",
    raping:"adult",
    ravishment: "adult",
    raw: "adult",
    school: "office",
    assault: "playing",
    harassment: "playing",
    stalking: "adult",
    teen: "adult",
    teenage: "adult",
    teenaged: "adult",
    teens: "adult",
    "under 18": "21+",
    underage: "adult",
    unethical: "adult",
    unfledged: "adult",
    unlawful: "adult",
    unripe: "adult",
    unripened: "adult",
    wrongful: "adult",
    youngish: "adult",
  
  };
  
  // Handle form submission
  const generate = async (_prompt, _pose, _style) => {
    // Show pending indicator
    if (!auth.user) {
      router.push('/auth/signin')
      return
    }
    if (!((auth.user.credit && auth.user.credit > 0) || (auth.user.extraCredit && auth.user.extraCredit > 0))){
      alert('Not enough credit')
      return
    }
    setPending(true);
    
    const seed = generateSeed()
    const styleData = modelStyles.find(x => x.value === style)
    // console.log("positive",prompt)
    // console.log("negaitve",negativePrompt)
    const adjustedPrompt=processPromptWithWordList(prompt, wordList)
    const adjustedNegativePrompt=processPromptWithWordList(negativePrompt, wordList)
    const improvedPrompt = styleData.goodPrompt.replace('SUBJECT',adjustedPrompt )
    const improvedNegativePrompt = styleData.badPrompt.replace('SUBJECT',adjustedNegativePrompt)
    // console.log(improvedPrompt)
    // console.log(improvedNegativePrompt)
      
    if ((prompt !== adjustedPrompt) || (negativePrompt!== adjustedNegativePrompt)) {
      setAdjustedUserPrompt(adjustedPrompt);
      setAdjustedUserNeagtivePrompt(adjustedNegativePrompt)
      setShowWarning(true);
      //  console.log("i am opened",prompt," ",adjustedPrompt)
      //  console.log("i am opened",negativePrompt," ",adjustedNegativePrompt)

    } else {
      setShowWarning(false);
    //   console.log("i am closed",prompt," ",adjustedPrompt)
    //   console.log("i am closed",negativePrompt," ",adjustedNegativePrompt)
    }

    const inputData = {
      prompt: _prompt || adjustedPrompt,
      negativePrompt: adjustedNegativePrompt,
      pose: _pose || pose,
      style: _style,
      seed: seed
    }    
    
    let prediction = await apiRequest("predictions", "POST", inputData);

    console.log(prediction)
  
    setPrediction(prediction);

    while (
      prediction.status !== "succeeded" &&
      prediction.status !== "failed"
    ) {
      await sleep(5000);
      const response = await fetch("/api/predictions/poll?" + new URLSearchParams({id: prediction.id}));
      prediction = await response.json();
      if (response.status !== 200) {
        setError(prediction.detail);
        return;
      }
      setPrediction(prediction);
    };
    setPending(false)
    if(prediction.status === "succeeded"){
      const imageFilename = prompt.replace(/[^a-z0-9]/gi, '_').toLowerCase();
      const imageURL = await uploadImageFromURL(prediction.output[0].image, `outputs/${auth.user.uid}_${imageFilename}_${new Date().getTime()}.png`)
      createItem({
        owner: auth.user.uid, 
        ownerName: auth.user.displayName,
        userPrompt: _prompt || adjustedPrompt,
        userNegativePrompt: adjustedNegativePrompt ,
        style: _style || style,
        pose: _pose || pose,
        isPrivate: isPrivate,
        isNSFW: prediction.output[0].nsfw,
        url: imageURL,
        ...prediction.input})
    }
    
    
  };

  // useEffect(() => {
  //   console.log('generate')
  //   if(auth.user){
  //     for (let i = 0; i< 5; i++){
  //       const p = PROMPTS.sample()
  //       generate(p, modelPoses.sample(), ['real', 'hyperreal', 'anime', 'hyperanime'].sample())
  //     }
  //   }
    
  // }, [auth, generated]);

  //const generateMutation = useItemsMutation(generate)
  const processPromptWithWordList = (prompt, wordList) => {
    let newText = String(prompt); // Ensure newText is a string
    console.log("this is my current ",prompt)
    for (const term in wordList) {
      const replacement = wordList[term];
      const escapedTerm = term.replace(/ /g, "\\s*"); // Replace spaces with regex for zero or more spaces
      const regex = new RegExp(escapedTerm, "gi"); // Match the term or phrase with spaces, case-insensitive
      newText = newText.replace(regex, String(replacement)); // Ensure replacement is a string
    }
    newText = newText.replace(/\b(?:[0-9]|1[0-8])\b/g, "20+");
    return newText;
  };
  const handleGenerate = () => {
    generate()
  }

  return (
    <form>
      <Grid container={true} spacing={2}>
        <Grid item={true} xs={12}>
          <TextField
            name="prompt"
            variant="outlined"
            type="string"
            label="Prompt"
            value={prompt}
            onChange={handleChange}
            fullWidth={true}
          />
        </Grid>
        <Grid item={true} xs={12}>
          <TextField
            name="negativePrompt"
            variant="outlined"
            type="string"
            label="Negative Prompt"
            placeholder="ugly, hat, earring"
            value={negativePrompt}
            onChange={handleChange}
            fullWidth={true}
          />
        </Grid>
        
        <Box clone mt={1} mb={3}>
          <Container>
            <Grid container={true} spacing={4} justifyContent="center">
              {modelStyles.map((item, index) => (
                    <Grid item={true} xs={6} md={3} key={index}>
                      <Card >
                        <CardActionArea onClick={() => handleStyleClick(item.value)}>
                          <CardMedia
                            style={{height: 130}}
                            image={item.image}
                            className={classes.media}
                          />
                          <Box
                            sx={{
                              position: 'absolute',
                              bottom: 0,
                              left: 0,
                              width: '100%',
                              bgcolor: item.value === style ? 'primary.dark' : 'rgba(0, 0, 0, 0.54)',
                              color: 'white',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="caption">{item.text}</Typography>
                          </Box>
                        </CardActionArea>
                      </Card>
                    </Grid>
                  ))}
            </Grid>
          </Container>
        </Box>

        <Grid item={true} xs={12} container={true} spacing={4} justifyContent="space-between">
          <Grid item={true}>
            <FormControl variant="outlined">
              <InputLabel id="style-label">Style</InputLabel>
              <Select
                name="style"
                onChange={handleChange}
                value={style}
                labelId="style-label"
                id="style-select"
                style={{width: 240}}
              >
                {modelStyles.map((item, index) => (
                  <MenuItem value={item.value}>{item.text}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item={true}>
            <FormControl variant="outlined">
              <InputLabel id="pose-label">Pose</InputLabel>
              <Select
                name="pose"
                onChange={handleChange}
                value={pose}
                labelId="pose-label"
                id="pose-select"
                style={{width: 240}}
              >
                {modelPoses.map((item, index) => (
                  <MenuItem value={item}>{item}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
        </Grid>

        <Grid item={true} xs={12}>
          <FormControlLabel
            control={
              <Switch checked={isPrivate} onChange={handleSwitch} name="isPrivate" color="primary"/>
            }
            label="Keep image private?"
          />
        </Grid>
        
        <Grid item={true} xs={12}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleGenerate}
            disabled={pending}
            fullWidth={true}
          >
            {!pending && <span>{props.buttonAction}</span>}

            {pending && <CircularProgress size={28} />}
          </Button>
        </Grid>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        borderRadius: '10px',
        padding: '1.25rem 1.25rem',
        border: '1px solid #1595a9',
        color: '#117b8c',
        width: '100%',
        background: 'rgba(23, 162, 184, 0.2)',
      }}
    >
      <Typography variant="subtitle1" style={{ fontSize: '12px' }}>
        <CheckBoxOutlined style={{ color: '#117b8c', fontSize: '12px' }} /> Unless an age is indicated, the default age for the prompt will be 25 years old.
      </Typography>
      <Typography variant="subtitle1" style={{ fontSize: '12px' }}>
        <CheckBoxOutlined style={{ color: '#117b8c', fontSize: '12px' }} /> Images depicting violence or gore are prohibited.
      </Typography>
      <Typography variant="subtitle1" style={{ fontSize: '12px' }}>
        <CheckBoxOutlined style={{ color: '#117b8c', fontSize: '12px' }} /> Please refrain from using celebrity names. Any images resembling celebrities will be deleted.
      </Typography>
      <Typography variant="subtitle1" style={{ fontSize: '12px' }}>
        <CheckBoxOutlined style={{ color: '#117b8c', fontSize: '12px' }} /> Images involving minors will not be produced.
      </Typography>
    </Box>
        {showWarning && (
          <PromptWarning
            prompt={prompt}
            improvedPrompt={adjustedUserPrompt}
            negativePrompt={negativePrompt}
            improvedNegativePrompt={adjustedUserNegativePrompt}
          />
        )}

        <Grid item={true} xs={12} justifyContent="center">
          {prediction && prediction.status === 'succeeded' && <img src={prediction.output[0].image}/>}
        </Grid>
      </Grid>
    </form>
  );
}

export default Generator;
